import { Availability } from 'core_main/sdk/is_chat_available/types';
import { mapOffhoursDisplayToAvailability } from 'globals/mapOffhoursDisplayToAvailability';
import { IFRAME_MESSAGES } from '../../globals/iframeMessages';
import { NormalizedStartParameters } from '../widget_api/types';

/**
 * Resolves widget chat availability after settings load.
 * Live preview can override business hours; automation test console can bypass "hidden".
 */
export const resolveChatAvailability = ({
  availability,
  offhoursDisplay,
  startParameters,
}: {
  availability: Availability;
  offhoursDisplay?: string;
  startParameters?: Pick<
    NormalizedStartParameters,
    | 'ignoreBusinessHoursAvailability'
    | 'testAutomationId'
    | 'livePreviewOverrides'
  >;
}): Availability => {
  const businessHoursOverride =
    startParameters?.livePreviewOverrides?.businessHours;

  if (businessHoursOverride === IFRAME_MESSAGES.INSIDE_BUSINESS_HOURS) {
    return 'online';
  }

  const shouldIgnoreBusinessHoursAvailability =
    startParameters?.ignoreBusinessHoursAvailability &&
    startParameters?.testAutomationId;

  if (shouldIgnoreBusinessHoursAvailability && availability === 'hidden') {
    return 'online';
  }

  if (businessHoursOverride === IFRAME_MESSAGES.OUTSIDE_BUSINESS_HOURS) {
    if (availability === 'disabled') {
      return availability;
    }

    return mapOffhoursDisplayToAvailability(offhoursDisplay);
  }

  return availability;
};
